import type {ReactNode} from 'react';
import type {VariantProps} from 'class-variance-authority';
import {cn} from '../lib/cn';
import {sectionTagVariants} from './sectionTagVariants';

export interface SectionTagProps extends VariantProps<typeof sectionTagVariants> {
  children?: ReactNode;
  className?: string;
}

export function SectionTag({children, color = 'green', className}: SectionTagProps) {
  return <div className={cn(sectionTagVariants({color}), className)}>{children}</div>;
}
